// removed by extract-text-webpack-plugin
module.exports = {"gray500":"#adb5bd","CardImage":"SignUpPreview__CardImage--180sZ","midFrame":"SignUpPreview__midFrame--1RPRj","innerFrame":"SignUpPreview__innerFrame--33N2W"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SignUp/SignUpPreview/SignUpPreview.scss
// module id = 424
// module chunks = 0